import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function ExportRecord() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
